var _defs, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 45.93 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .st1 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.93,
    cy: 11.52,
    r: 9.73,
    transform: "translate(-1.55 3.82) rotate(-9.22)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.16,11.52,12.37,8.09C13.35,3.5,17.81-.38,22.93-.54c6.43-.48,12.66,5.37,12.49,12.06.17,6.68-6.06,12.54-12.49,12.06-5.11-.16-9.58-4.03-10.55-8.63-.26-1.14-.26-5.72,0-6.86Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.93,
    cy: 11.52,
    r: 9.73,
    transform: "translate(-1.55 3.82) rotate(-9.22)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75,62.38c.02.28.14.55.35.75.21.2.48.31.76.31s.55-.11.76-.31c.21-.2.32-.47.35-.75.12-1.57.24-3.15.35-4.72.26-3.64.68-7.27.67-10.92-.05-12.96,8.9-19.38,17.98-19.19,9.08-.2,17.98,6.22,17.98,19.19,0,3.64.41,7.28.67,10.92.11,1.57.23,3.15.35,4.72.02.28.14.55.35.75.21.2.48.31.76.31s.55-.11.76-.31c.21-.2.32-.47.35-.75.12-1.57.24-3.15.35-4.72.26-3.64.48-7.28.67-10.92.91-11.85-9.89-23.38-22.23-23.06C10.62,23.36-.18,34.89.73,46.74c.19,3.64.41,7.28.67,10.92.11,1.57.23,3.15.35,4.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.08,48.88c-.13.03-.26.09-.35.19-.09.1-.15.23-.15.36s.05.26.15.36c.09.1.22.16.35.19.29.06.59.12.88.18,2.65.5,5.31.75,7.96.75s5.31-.25,7.96-.75c.29-.06.59-.11.88-.18.13-.03.26-.09.35-.19.09-.1.15-.23.15-.36s-.05-.26-.15-.36c-.09-.1-.22-.16-.35-.19-.29-.06-.59-.12-.88-.18-2.65-.5-5.31-.75-7.96-.75s-5.31.25-7.96.75c-.29.06-.59.11-.88.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.8a0b0d0753ffd57b7c6f2bc708722843.svg";
export { ForwardRef as ReactComponent };